import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_USER,
  storeGet,
} from 'mailup-react-helpers'

import { TOAST_VARIANT_SUCCESS, toastShow } from 'mailup-web-components'

import getIntl from 'Helpers/intl'

import { beAccountSettingsApiSendContactRequest } from 'Api/beAccountSettingsApi'

export const getUserEmail = async (): Promise<string> => {
  const { RecoverEmail } = storeGet(STORE_KEY_USER)

  return RecoverEmail ?? ''
}

export const sendContactRequest = async (email: string): Promise<void> => {
  const { Id }: { Id: number } = storeGet(STORE_KEY_ACCOUNT)

  await beAccountSettingsApiSendContactRequest({
    Title: `Piattaforma ${Id} - Filtri di Engagement`,
    Description: `Email: ${email}
L'utente ha dimostrato interesse al prodotto lasciando il proprio contatto nella pagina: Recipients Overview
Codice prodotto di riferimento: MUFIENG01`,
  })
}

export const notifyEngagementUpsellingContactSendSuccess = (): void => {
  toastShow(
    getIntl().formatMessage({
      id: 'Load.RecipientsList.ModalDelStatsContactSuccess',
    }),
    TOAST_VARIANT_SUCCESS,
  )
}
